export const needsStudentLink = (enquiryOrRow) => {
  if (!enquiryOrRow) return false;
  const student = enquiryOrRow.student;
  if (!student) return true;
  if (typeof student === 'object' && !student._id) return true;
  return false;
};

export const getLinkedStudent = (student) => {
  if (!student) return null;
  if (typeof student === 'object' && student._id) return student;
  return null;
};

export const formatStudentName = (student) => {
  const linked = getLinkedStudent(student);
  if (!linked) return 'Not linked';
  return `${linked.firstName || ''} ${linked.lastName || ''}`.trim() || 'Not linked';
};

export const formatStudentClass = (student) => {
  const linked = getLinkedStudent(student);
  if (!linked) return '-';
  return linked.class || linked.standard || '-';
};
